import { config } from "@react-spring/web";
import TextTransition from "./components/TextTransition";
export { config as presets };
export default TextTransition;
//# sourceMappingURL=index.js.map